import React from 'react';
import { Zap } from 'lucide-react';

export function GenerateButton({ isGenerating, progress, onTriggerGenerate }) {
  return (
    <div style={{ marginTop: 'auto', paddingTop: '16px' }}>
      <button
        type="button"
        onClick={onTriggerGenerate}
        disabled={isGenerating}
        style={{
          width: '100%',
          padding: '14px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
          color: '#fff',
          fontWeight: 700,
          fontSize: '14px',
          border: 'none',
          cursor: isGenerating ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(168, 85, 247, 0.4)',
          transition: 'all 0.2s'
        }}
      >
        <Zap size={16} />
        {isGenerating ? `Renderizando (${progress}%)...` : '⚡ Generar con Google Veo'}
      </button>
      <div style={{ textAlign: 'center', fontSize: '11px', color: '#64748b', marginTop: '6px' }}>
        Tiempo estimado: ~15s • Calidad cinematográfica 4K
      </div>
    </div>
  );
}
